// extracted by mini-css-extract-plugin
export default {"user-block":"profileInfo_user-block__+Utql"};